<template>
  <div>
    <v-row class="mb-2">
      <v-col cols="12" sm="6">
        <time-picker
          v-model="timingSettings.reset_time"
          :label="$t('reset_time')"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'voucher'">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.quantity_in_period"
          :label="$t('how_many_vouchers_daily')"
          type="number"
          :hint="$t('number_of_vouchers_available_daily')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'order'">
      <v-col v-if="config.settings.limit_by_quantity" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_orders"
          :label="$t('how_many_orders_daily')"
          type="number"
          :hint="$t('max_orders_hint')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
      <v-col v-if="config.settings.limit_by_value" cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_order_value"
          :label="$t('max_order_value')"
          type="number"
          :suffix="restaurantCurrency"
          :hint="$t('max_order_value_hint')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'credit'">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.max_amount"
          :label="$t('credit_amount_daily')"
          type="number"
          :suffix="restaurantCurrency"
          outlined
          dense
          :hint="$t('credit_amount_renews_daily')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row v-if="activeType === 'money'">
      <v-col cols="12" sm="6">
        <text-field
          v-model.number="config.settings.limit_amount"
          :label="$t('money_limit_amount_daily')"
          type="number"
          :suffix="restaurantCurrency"
          outlined
          dense
          :hint="$t('money_limit_amount_daily_hint')"
          persistent-hint
          :readonly="readonly"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "DailyLimitFields",
  props: {
    config: {
      type: Object,
      required: true,
    },
    timingSettings: {
      type: Object,
      required: true,
    },
    activeType: {
      type: String,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
